import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button, Icon } from 'antd';
import classes from '../styles/order/OrderInfo.module.scss';
import { formatNumber, formatPvCode } from 'utils/formatting';

import { dateTh, formatDate } from 'utils/formatDate';
import _ from 'lodash';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const formatTime = (timeNumber) => {
  return moment(`${timeNumber}`, 'Hmm').format('HH:mm');
};
const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const OrderRevenue = ({ revenue, orderItem, onApproveOrder, onCancelOrder, openEditPaymentModal }) => {
  const student = orderItem.student;

  const discountList = [];
  if (orderItem.promocodeDiscountAmount) {
    discountList.push({
      type: 'promocode',
      amount: orderItem.promocodeDiscountAmount,
    });
  }
  if (parseFloat(orderItem.fullprice).toFixed(2) !== parseFloat(orderItem.price).toFixed(2)) {
    discountList.push({
      type: 'classDiscount',
      amount: orderItem.fullprice - orderItem.price,
    });
  }

  return (
    <div className={cn(classes.orderRevenueContainer)}>
      <Row gutter={12}>
        <Col xs={12}>
          <div className="content">
            <table>
              <thead>
                <tr className="bold">
                  <td>Description</td>
                  <td className="text-right">Price</td>
                  <td>Qty.</td>
                  <td className="text-right">Total</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ค่าเรียน</td>
                  <td className="text-right">{formatPrice(orderItem.class.price)}</td>
                  <td>1</td>
                  <td className="text-right">{formatPrice(orderItem.class.price)}</td>
                </tr>

                <tr>
                  <td className="">Special Discount</td>
                  <td />
                  <td />
                  <td className="text-right red">({formatPrice(orderItem.fullprice - orderItem.price)})</td>
                </tr>

                <tr className="bold-border-top">
                  <td className={'bold'}>
                    Teacher
                    {"'"}s Revenue
                  </td>
                  <td />
                  <td />
                  <td className="text-right">{formatPrice(orderItem.price)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={12}>
          <div className="content">
            <table>
              <thead>
                <tr className="bold">
                  <td>Name</td>

                  <td className={'text-right'}>Total</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Net Com</td>

                  <td className="text-right">{formatPrice(orderItem.serviceFee - orderItem.cardFee)}</td>
                </tr>
                <tr>
                  <td>Processing Fee</td>

                  <td className="text-right">{formatPrice(orderItem.cardFee)}</td>
                </tr>

                {/* <tr>
                  <td>T-Points</td>
                  <td />
                  <td />
                  {orderItem.points > 0 ? <td className="red text-right">- {formatPrice(orderItem.points)}</td> : <td className="text-right">0.00</td>}
                </tr> */}

                <tr className="bold-border-top">
                  <td className={'bold'}>Payout</td>

                  <td className="text-right">{formatPrice(orderItem.price - (orderItem.serviceFee || 0))}</td>
                </tr>
                <tr className="bold-border-top">
                  <td className={'bold'}>Payout Date & Time</td>
                  <td className="text-right">{orderItem.withdrawal && moment(orderItem.withdrawal.approvedDate).format('DD/MM/YYYY | HH:mm')}</td>
                </tr>
                <tr className="bold-border-top">
                  <td className={'bold'}>PV No.</td>

                  <td className="text-right">{orderItem.withdrawal && formatPvCode(orderItem.withdrawal)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>

      {/* <div className="content text-center">
        <Row>
          <Col xs={11} className={'text-right'}>
            <Button
              type="danger"
              size="large"
              disabled={orderItem.status === 'rejected' || orderItem.status === 'success'}
              onClick={orderItem.status !== 'rejected' && orderItem.status !== 'success' && onCancelOrder}
            >
              Reject
            </Button>
          </Col>
          <Col xs={2} />

          <Col xs={11} className={'text-left'}>
            <Button
              type="success"
              size="large"
              disabled={orderItem.status === 'rejected' || orderItem.status === 'paid' || orderItem.status === 'success' || (orderItem.status === 'confirm' && _.get(orderItem, 'schedule.isSummary'))}
              onClick={
                !(orderItem.status === 'rejected' || orderItem.status === 'paid' || orderItem.status === 'success' || (orderItem.status === 'confirm' && _.get(orderItem, 'schedule.isSummary'))) &&
                onApproveOrder
              }
            >
              Approve
            </Button>{' '}
          </Col>
        </Row>
      </div> */}
    </div>
  );
};

export default OrderRevenue;
